import { MessageTemplateDataFragment } from "@hire/schema";

export const transformIn = (data?: MessageTemplateDataFragment) => {
  return { name: data?.name ?? "", message: data?.message ?? "" };
};
